import React, { useEffect, createElement } from 'react';
import { Hero } from '../components/Hero';
import { PainSection } from '../components/PainSection';
import { MechanismSection } from '../components/MechanismSection';
import { WhatYouGet } from '../components/WhatYouGet';
import { AudienceSection } from '../components/AudienceSection';
import { CtaSection } from '../components/CtaSection';
import { Footer } from '../components/Footer';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function SalesPage() {
  useEffect(() => {
    // Load Meta Pixel script
    if (!window.fbq) {
      const n: any = window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
      window.fbq('init', '782547894469810');
    }
    // Fire PageView
    window.fbq('track', 'PageView');
  }, []);
  return <main className="w-full min-h-screen bg-[#0a0e1a] text-slate-100 selection:bg-amber-500/30 selection:text-amber-100" data-id="element-169">
      <Hero data-id="element-170" />
      <PainSection data-id="element-171" />
      <MechanismSection data-id="element-172" />
      <WhatYouGet data-id="element-173" />
      <AudienceSection data-id="element-174" />
      <CtaSection data-id="element-175" />
      <Footer data-id="element-176" />
    </main>;
}